// Environment variables - Vite/Vitest will replace import.meta.env at build/test time
// Vitest handles import.meta.env automatically when envPrefix: ['VITE_'] is set
const envVars = import.meta.env || {};

/** Branch / deploy env name → customers API subdomain segment (dev, prod, …) */
const customersApiEnvByBranch = {
  development: 'dev',
  master: 'prod',
};

const config = {
  apiRoot: envVars.VITE_API_URL
  ? envVars.VITE_API_URL
  :envVars.VITE_ENV
    ? `https://${envVars.VITE_ENV}-api.${envVars.VITE_HOSTED_ZONE_NAME}`
    : 'http://localhost:8090',

  customersApiServiceRoot: envVars.VITE_CUSTOMERS_API_SERVICE_URL
  ? envVars.VITE_CUSTOMERS_API_SERVICE_URL
  : envVars.VITE_ENV
    ? `https://${customersApiEnvByBranch[envVars.VITE_ENV] ?? envVars.VITE_ENV}-customers-api.${envVars.VITE_HOSTED_ZONE_NAME}/api`
    : 'http://localhost:8095/api',

  tokenKey: 'authorization_token',
  redirectRouteOnAuthenticationFaliure: '/login',

  featureFlagConfig: {
    sdkKey: envVars.VITE_FEATURE_FLAG_SDK_KEY,
    featureFlagProvider: envVars.VITE_FEATURE_FLAG_PROVIDER || 'default',
    environment: envVars.VITE_FEATURE_FLAG_ENV || 'production',
  },
};

export const env = {
  environment: envVars.VITE_ENV,
};

export const version = {
  commitVersion: envVars.VITE_COMMIT_VERSION,
  releaseNumber: '9.7',
};

export default config;
